import React from "react";
import RegistrationBannerCommon from "@clarion/feature/dist/SiteComponents/components/RegistrationBanner/index";

const RegistrationBanner = (props) => <RegistrationBannerCommon {...props} />;

export default RegistrationBanner;
